if (!customElements.get('sm-mail-in')) {
  customElements.define('sm-mail-in', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('[data-sm-copy]')?.addEventListener('click', async () => {
        const textarea = this.querySelector('[data-sm-copy-text]');
        const status = this.querySelector('[data-sm-copy-status]');
        try {
          await navigator.clipboard.writeText(textarea.value);
          status.textContent = this.dataset.copied;
          textarea.hidden = true;
        } catch {
          textarea.hidden = false;
          textarea.focus();
          textarea.select();
          status.textContent = this.dataset.copyFallback;
        }
      });
      this.querySelector('[data-sm-print]')?.addEventListener('click', () => window.print());
      const root = this.querySelector('.sm-mail-in__form');
      if (root) {
        const sync = () => {
          root.querySelectorAll('input.checkbox-input[id*="-consent-"]').forEach(input => {
            if (input.hasAttribute('presence')) input.setAttribute('aria-required', 'true');
            const control = input.closest('.globo-form-control');
            if (control?.classList.contains('has-error')) input.setAttribute('aria-invalid', 'true');
            else input.removeAttribute('aria-invalid');
            const label = input.parentElement?.querySelector('label.checkbox-label[tabindex]');
            if (label?.htmlFor === input.id) label.removeAttribute('tabindex');
          });
        };
        this.observer = new MutationObserver(sync);
        this.observer.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
        sync();
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
